import { AlertTriangle } from 'lucide-react'

interface PostOperationChecklistProps {
  onDone: () => void
}

export default function PostOperationChecklist({ onDone }: PostOperationChecklistProps) {
  return (
    <div className="space-y-5">
      <div className="bg-emerald-50 border-2 border-emerald-300 rounded-xl p-4 sm:p-5">
        <div className="flex items-start gap-3 mb-4">
          <div className="shrink-0 mt-0.5">
            <AlertTriangle className="w-6 h-6 text-emerald-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-base font-semibold text-emerald-900 mb-3">
              Turn these back on now:
            </h3>

            <div className="space-y-2.5">
              <div className="flex items-start gap-3 bg-white/60 rounded-lg p-2.5">
                <span className="shrink-0 w-6 h-6 rounded-full bg-emerald-600 text-white flex items-center justify-center text-xs font-bold">
                  1
                </span>
                <div>
                  <p className="text-sm font-semibold text-emerald-900">Stolen Device Protection</p>
                  <p className="text-xs text-emerald-700">
                    <strong>Settings &rarr; Face ID &amp; Passcode &rarr; Stolen Device Protection</strong> &rarr; Turn On
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white/60 rounded-lg p-2.5">
                <span className="shrink-0 w-6 h-6 rounded-full bg-emerald-600 text-white flex items-center justify-center text-xs font-bold">
                  2
                </span>
                <div>
                  <p className="text-sm font-semibold text-emerald-900">Find My iPhone</p>
                  <p className="text-xs text-emerald-700">
                    <strong>Settings &rarr; [Your Name] &rarr; Find My &rarr; Find My iPhone</strong> &rarr; Turn On
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={onDone}
        className="w-full py-3 text-sm font-medium text-white bg-emerald-600 rounded-xl hover:bg-emerald-700 active:bg-emerald-800 transition-colors"
      >
        Done - I&apos;ve turned them back on
      </button>
    </div>
  )
}
